<script lang="ts">
  export type QuickAction = { id: string; label: string; icon?: string };

  let {
    actions,
    onAction,
  }: {
    actions: QuickAction[];
    onAction: (id: string) => void;
  } = $props();
</script>

<div class="actions">
  {#each actions as a (a.id)}
    <button type="button" onclick={() => onAction(a.id)}>
      {#if a.icon}<span class="ico">{a.icon}</span>{/if}
      {a.label}
    </button>
  {/each}
</div>

<style>
  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    margin-bottom: 1rem;
    padding: 0.55rem 0.65rem;
    background: color-mix(in srgb, var(--brand-soft) 40%, var(--bg-elevated));
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
  }
  button {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.45rem 0.9rem;
    border-radius: 999px;
    border: 1px solid color-mix(in srgb, var(--brand) 35%, var(--border));
    background: var(--bg-surface);
    color: var(--brand-deep);
    font: inherit;
    font-size: 0.8rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.12s, background 0.15s, box-shadow 0.15s;
    box-shadow: var(--shadow-sm);
  }
  button:hover {
    background: var(--brand-soft);
    border-color: var(--brand);
    transform: translateY(-1px);
  }
  .ico { font-size: 1rem; }
</style>
